// Link do "Indique e ganhe" (myplanner://baixar?i=CODIGO ou /baixar?i=CODIGO). No site, antes de entrar,
// a página pública aparece pelo _layout. Aqui, com o app aberto, o código já foi guardado: volta para o início.
import { Redirect } from 'expo-router';
export { ErrorBoundary } from '../components/Falha';
export default function Baixar() { return <Redirect href="/" />; }
